import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
// import { sentenceCase } from 'change-case';
import { useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import axios from "axios";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
// components
import Label from "../components/label";
import Iconify from "../components/iconify";
// sections
import { UserListHead, UserListToolbar } from "./UserListHead";
// mock
// import USERLIST from '../_mock/user';
import { toast } from "react-hot-toast";
import { mainServerAppUrl } from "../../../apis/mainApi";
import Header from "../layout/dashboard/header";
import Nav from "../layout/dashboard/nav";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import UserDetails from "./userDetails";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "srno", label: "Sr. No.", alignRight: false },
  { id: "date", label: "Date", alignRight: false },
  { id: "mealhost", label: "Mealhost", alignRight: false },
  { id: "mealtype", label: "Type", alignRight: false },
  { id: "mealname", label: "Meal Name", alignRight: false },
  { id: "qty", label: "Qty", alignRight: false },
  { id: "amount", label: "Amount", alignRight: false },
  { id: "status", label: "Status", alignRight: false },
  { id: "invoice", label: "invoice", alignRight: false },
];

// ----------------------------------------------------------------------
const USERLIST = [];
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function OrdersByPatron({onClose,orders}) {

  
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState("asc");

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState("name");

  const [filterName, setFilterName] = useState("");


  const [rowsPerPage, setRowsPerPage] = useState(5);
  // State for invoice modal
  const [openInvoice, setOpenInvoice] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // const handleClick = (event, name) => {
  //   const selectedIndex = selected.indexOf(name);
  //   let newSelected = [];
  //   if (selectedIndex === -1) {
  //     newSelected = newSelected.concat(selected, name);
  //   } else if (selectedIndex === 0) {
  //     newSelected = newSelected.concat(selected.slice(1));
  //   } else if (selectedIndex === selected.length - 1) {
  //     newSelected = newSelected.concat(selected.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
  //   }
  //   setSelected(newSelected);
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

//     const handleCloseUserDetails = () => {
//     setShowUserDetails(false);
//   };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - orders.length) : 0;

  const filteredUsers = applySortFilter(
    USERLIST,
    getComparator(order, orderBy),
    filterName
  );

  const isNotFound = !filteredUsers.length && !!filterName;

  const APP_BAR_MOBILE = 64;
  const APP_BAR_DESKTOP = 92;

  const StyledRoot = styled("div")({
    display: "flex",
    minHeight: "100%",
    overflow: "hidden",
  });

  const Main = styled("div")(({ theme }) => ({
    flexGrow: 1,
    overflow: "auto",
    minHeight: "100%",
    paddingTop: APP_BAR_MOBILE + 24,
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up("lg")]: {
      paddingTop: APP_BAR_DESKTOP + 24,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  }));

return (
  <>
    <Container>
      {/* Header */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <h5>Order Details:</h5>

        <MenuItem sx={{ color: "black" }} onClick={onClose}>
          <Tooltip title="Close">
            <Iconify icon={"eva:close-fill"} />
          </Tooltip>
        </MenuItem>
      </Stack>

      {/* Table Card */}
      <Card>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <UserListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={orders.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
              onSelectAllClick={handleSelectAllClick}
            />

            <TableBody>
              {orders
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((order, ind) => (
                  <TableRow key={order._id}>
                    <TableCell>{ind + 1}</TableCell>

                    <TableCell>
                      {new Date(order.ordered_On).toLocaleString()}
                    </TableCell>

                    <TableCell>
                      {order.meal_host} ({order.mealhost_id})
                    </TableCell>

                    <TableCell>{order.meal_type}</TableCell>
                    <TableCell>{order.meal_name}</TableCell>
                    <TableCell>{order.order_quantity}</TableCell>
                    <TableCell>{order.price}</TableCell>

                    {/* Status */}
                    <TableCell
                      sx={{
                        color:
                          order.order_status === "delivered" ||
                          order.order_status === "confirmed"
                            ? "green"
                            : order.order_status === "processing"
                            ? "orange"
                            : "red",
                      }}
                    >
                      {order.order_status === "delivered"
                        ? "Served"
                        : order.order_status}
                    </TableCell>

                    {/* Invoice Action */}
                    <TableCell align="right">
                      {order.order_status === "delivered" ||
                      order.order_status === "confirmed" ? (
                        <MenuItem
                          sx={{ color: "green" }}
                          onClick={() => {
                            console.log('Selected order for invoice modal:', order);
                            setSelectedOrder(order);
                            setOpenInvoice(true);
                          }}
                        >
                          <Tooltip title="Show Invoice">
                            <Iconify icon="eva:file-text-outline" />
                          </Tooltip>
                        </MenuItem>
                      ) : (
                        <MenuItem disabled>
                          <Iconify icon="carbon:not-available" />
                        </MenuItem>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>

            {/* Empty State */}
            {isNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    <Paper sx={{ py: 3 }}>
                      <Typography variant="h6">Not found</Typography>
                      <Typography variant="body2">
                        No results for <b>{filterName}</b>
                      </Typography>
                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={orders.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>

    {/* ✅ Invoice Dialog (ONLY ONCE) */}
    <Dialog
      open={openInvoice}
      onClose={() => setOpenInvoice(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Invoice Details</DialogTitle>

      <DialogContent>
        {selectedOrder?.payment ? (
          <>
            <Typography><b>Order ID:</b> {selectedOrder._id}</Typography>
            <Typography><b>Amount:</b> ₹{selectedOrder.price}</Typography>
            <Typography><b>Status:</b> {selectedOrder.order_status}</Typography>
            <Typography>
              <b>Invoice:</b>{" "}
              {selectedOrder.payment.invoiceURL ? (
                <a
                  href={selectedOrder.payment.invoiceURL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Invoice
                </a>
              ) : (
                <span style={{color: 'red'}}>Invoice URL not available.</span>
              )}
            </Typography>
          </>
        ) : selectedOrder ? (
          <>
            <Typography color="error">Invoice details not available for this order.</Typography>
            <pre style={{background:'#f5f5f5',padding:'8px',fontSize:'12px',overflow:'auto'}}>{JSON.stringify(selectedOrder, null, 2)}</pre>
          </>
        ) : (
          <Typography>Invoice details not available.</Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenInvoice(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  </>
);

}
